import robustFetch from '@/utils/robustFetch';
export interface SiteSettings {
  siteName: string;
  domain?: string | null;
  baseUrl?: string | null;
  logoUrl?: string | null;
  faviconUrl?: string | null;
  defaultMetaTitle?: string | null;
  defaultMetaDescription?: string | null;
  defaultKeywords?: string | null;
  twitterHandle?: string | null;
  ogImageUrl?: string | null;
  googleSiteVerification?: string | null;
  msValidate?: string | null;
  yandexVerification?: string | null;
  organizationJson?: any | null;
  additionalJsonLd?: any | null;
}

let cachedSettings: SiteSettings | null = null;
let inflight: Promise<SiteSettings> | null = null;

export async function getPublicSiteSettings(
  force = false,
): Promise<SiteSettings> {
  if (!force && cachedSettings) return cachedSettings;
  if (inflight) return inflight;
  inflight = robustFetch("/api/seo/site-settings")
    .then(async (r) => {
      if (!r.ok) throw new Error("Failed to load site settings");
      const json = await r.json();
      return json.data as SiteSettings;
    })
    .then((data) => {
      cachedSettings = data;
      inflight = null;
      return data;
    })
    .catch((e) => {
      inflight = null;
      throw e;
    });
  return inflight;
}

export async function getAdminSiteSettings(): Promise<SiteSettings> {
  const token = localStorage.getItem("auth_token");
  const headers: Record<string, string> = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const r = await robustFetch("/api/admin/seo/settings", { headers });
  if (!r.ok) throw new Error("Failed to load admin site settings");
  const json = await r.json();
  return json.data as SiteSettings;
}

export async function updateAdminSiteSettings(data: Partial<SiteSettings>) {
  const token = localStorage.getItem("auth_token");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const r = await robustFetch("/api/admin/seo/settings", {
    method: "PUT",
    headers,
    body: JSON.stringify(data),
  });
  if (!r.ok) throw new Error("Failed to save site settings");
  const json = await r.json();
  cachedSettings = json.data; // refresh cache
  return json.data as SiteSettings;
}
